
import { PAGE_TYPE, SEARCH_QUERY } from "./-search.query";
import { seoMixin, pageMixin } from "~/mixins";

const UID = "product-search";

export default {
  mixins: [seoMixin, pageMixin],

  async asyncData({ app }) {
    const { [PAGE_TYPE]: data } = await app.$prismicGql.request({
      query: SEARCH_QUERY,
      variables: { uid: UID, lazy: false },
    });

    return {
      pageType: PAGE_TYPE,
      uid: UID,
      slices: data.slices,
      title: data.title,
      metaTitle: data.metaTitle,
      metaDescription: data.metaDescription,
      metaRobots: data.metaRobots,
      metaFields: { _linkType: data._linkType, _meta: data._meta },
    };
  },

  async fetch() {
    await this.$store.dispatch("productsSearch/start", {
      queryPath: this.$route.fullPath.replace(this.$route.path, ""),
      pageSize: this.$route.query.view_all
        ? 1000
        : this.$device.isMobile
        ? 18
        : 12,
    });

    const redirect =
      this.$store.state.productsSearch.initialPageResult?.merchandising
        .redirect;

    if (redirect) {
      this.$router.push({ path: redirect });
    }
  },

  computed: {
    /**
     * Search breadcrumb title (SSR-safe)
     * Derived from search query, not CMS label
     */
    searchBreadcrumbTitle() {
      const query = this.$route.query.query;

      if (!query) {
        // Fallback
        return this.title;
      }

      // Normalize query. example: "queen beds" to "Queen Beds"
      const formatted = query
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");

      return [{ text: formatted }];
    },
  },

  watch: {
    "$route.query.query": "$fetch",
  },

  beforeDestroy() {
    this.$store.dispatch("app/CLOSE_FILTER_PANEL");
    this.$store.dispatch("productsSearch/dispose");
  },

  methods: {
    getDescription(item) {
      return item?.item?.meta?.snooze?.description_title ?? "";
    },
  },
};
